import React from 'react';
export const PlaybackRateButton = ({ children, onClick }) => (React.createElement("button", { className: 'str-chat__message_attachment__playback-rate-button', "data-testid": 'playback-rate-button', onClick: onClick }, children));
